/******************************************************************************
*   Login Object
*******************************************************************************
* Used to describe a dynamic login form.
******************************************************************************/

var checkoutAPIversion = 7;

Login = function(wrapper) {
    var login = this;

    this.$wrap = $(wrapper);
    this.$anchor = login.$wrap.find('a[name=login], .js-next-step-btn');
    this.$loadingOverlay = login.$wrap.find('.login-loading-overlay, .js-login-loading');
    this.$loadingMsg = this.$loadingOverlay.find('.msg-text, .js-login-loading-msg');
    this.$error = login.$wrap.find('.login-error, .js-login-error');
    this.$errorMsg = this.$error.find('.msg-text');
    this.$errorX = this.$error.find( ".close" );
    this.$lockout = login.$wrap.find('.login-lockout, .js-login-lockout');
    this.$lockoutMsg = login.$wrap.find('.msg-text');
    this.$lockoutX = this.$lockout.find( ".close" );
    this.$headerLogin = $('.js-login-link');
	this.$newAccount = login.$wrap.find('.newAccount');
    this.$createAccount = login.$wrap.find('.login-create-account, .js-create-account');
	this.$createNewAccount = login.$wrap.find('.newaccount-create-account');
	this.$formNewCustomer = login.$wrap.find('form#newCustomer');
    this.$newCustomerModal = $( ".js-new-customer-modal" );
    if( this.$newCustomerModal.length ) {
        this.$formNewCustomer = this.$newCustomerModal.find( "form" );
        this.$newAccount = this.$newCustomerModal;
    }
    this.$guest = login.$wrap.find( ".js-guest" );
	this.$submit = login.$wrap.find('.login-submit, .js-login-submit-btn, .js-login');
    this.$email = login.$wrap.find('.login-email, .js-login-email');
    this.$password = login.$wrap.find('.login-password, .js-login-password');
    this.$recaptchaToken = login.$wrap.find('.js-recaptcha-token');
    this.$passwordLbl = login.$wrap.find('.login-password-label, .js-login-password-label');
    this.$passphrase = login.$wrap.find('.login-passphrase, .js-login-passphrase');
	this.$rememberMe = login.$wrap.find('.login-remember-me, .js-login-remember');
    this.$rememberMeLbl = login.$wrap.find( ".js-login-remember-label" );
    this.$desc = login.$wrap.find('.login-desc, .js-login-desc');
    this.$recover = login.$wrap.find('.login-recover, .js-login-forgot');
    this.$recoverDesc = login.$wrap.find('.login-recover-desc, .js-recover-desc');
    this.$recoverSubmit = login.$wrap.find('.login-recover-submit, .js-recover-submit');
    this.$recoverCancel = login.$wrap.find('.login-recover-cancel, .js-recover-cancel');
    this.$recoverError = login.$wrap.find('.login-recover-error, .js-recover-error');
    this.$recoverErrorX = this.$recoverError.find( ".close" );
    this.$createError = login.$newCustomerModal.find( ".js-create-error" );
    this.$createErrorX = login.$createError.find( ".close" );
    this.callbacks = {};
    this.cachedLoginResult = false;
	this.cachedFullLogin   = false;

    this.init = function() {
        login.loading();
        login.listen();

        if($("#isLoggedIn").val()) {
            login.cachedLoginResult = "loggedIn";
        }
        if($("#isFullLogin").val()) {
            login.cachedFullLogin = "fullLogin";
        }

        login.$recoverDesc.hide();
        login.$recoverSubmit.hide();
        login.$recoverCancel.hide();
    };

    this.listen = function() {
        login.$submit.on('click.login', login.submit);

        login.$recover.click(login.toggleRecover);

        login.$recoverCancel.click(login.toggleRecover);

        login.$recoverSubmit.click(login.recover);

        login.$createAccount.click( login.showCreateAccount );

        login.$formNewCustomer.submit( login.doCreateNewAccount );

        login.$newCustomerModal.on( "show.bs.modal", function() { login.$wrap.hide() } );
        // login.$newCustomerModal.on( "hide.bs.modal", function() { login.$wrap.show() } );

        login.$errorX.click( function() { login.$error.hide() } );
        login.$lockoutX.click( function() { login.$lockout.hide() } );
        login.$recoverErrorX.click( function() { login.$recover.hide() } );
        login.$createErrorX.click( function() { login.$createError.hide() } );

        $( ".js-show-password-link" ).on( 'click', login.showPassword);
    };
	
	this.showPassword = function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		e.stopPropagation();
		$this = $(this);
		if ($this.text().toLowerCase() == 'show') {
			$this.text('Hide');
		} else {
			$this.text('Show');
		}
		login.togglePassword( $($this.data('target')) );
	};

    this.togglePassword = function( $target ) {
		var newType = ( $target.prop( "type" ) == "text" )
			? "password"
			: "text";
		$target.prop( "type", newType );
    };

    this.submit = function() {
        var email = login.$email.val(),
            password = login.$password.val(),
            recaptchaToken = login.$recaptchaToken.val(),
            passphrase = login.$passphrase.val();

        login.error(false);

        if(! email
            || ! password
            || ! isValidEmailAddress(email)
            ) {
            login.error(true);
            return false;
        }

				var rememberMe = false;
				if ( login.$rememberMe && login.$rememberMe.is(':checked') ) {
					rememberMe = true;
				}


        login.doLogin({
            'version'  		: checkoutAPIversion,
            'step'     		: "billship",
            'action'   		: "login",
            'email'    		: email,
            'password' 		: password,
            'g-recaptcha-response' : recaptchaToken,
            'rememberMe'	: rememberMe,
            'passphrase'    : passphrase,
        });

        return false;
    };

        
		this.resetForm = function() {
			login.$wrap.find('.newAccount').hide();
			login.$wrap.find('.rcustomer,.ncustomer,.medialogin').show();	
            login.$wrap.find( ".column" ).show();
            login.$wrap.find( ".js-new-account" ).hide();
		};

		this.showCreateAccount = function(e) {
			login.$wrap.find('.ncustomer,.rcustomer,.medialogin,.newAccount').toggle();

            // if we're in checkout, open the new modal
            if( login.$newCustomerModal.length ) {
                login.$newCustomerModal.modal( "show" );
            }
			e.preventDefault();
		};

    this.doCreateNewAccount = function( e ) {
        e.preventDefault();
				
        var email = login.$newAccount.find('#nc-email').val(),
            password = login.$newAccount.find('#nc-password').val(),
							zip	= login.$newAccount.find('#nc-zip').val();

        login.createError(false);

        if(! email
            || ! password
            || ! isValidEmailAddress(email)
            ) {
            login.createError(true);
            return false;
        }

				var rememberMe = false;
				if ( login.$newAccount && login.$newAccount.find('#nc-remember-me').is(':checked') ) {
					rememberMe = true;
				}


        login.doLogin({
						'version'  		: checkoutAPIversion,
						'step'     		: "billship",
						'action'   		: "createAccount",
						'email'    		: email,
						'password' 		: password,
						'rememberMe'	: rememberMe,
						'zip'					: zip,
        });
        login.$newCustomerModal.modal( "hide" );

		return false;
    };

    this.doLogin = function(postData) {
        var callbacks = login.callbacks.submit;
        login.loading("Logging In");
        if (!postData['g-recaptcha-response']) 
            return;
        if (login.inLogin)
            return; 

        login.inLogin = true;
        $.ajax({
            'url'      : window.checkoutEndpoint,
            'cache'    : false,
            'type'     : "POST",
            'dataType' : "json",
            'data'     : postData
            })
            .done(function(response) {
                login.$headerLogin.html('Sign Out');
                login.$headerLogin.attr({
                    href: '/MyAccount/Logout/',
                    title: 'Sign out of My Account'
                });

                login.cachedLoginResult = "loggedIn";

                if(callbacks
                    && callbacks.done
                    ) {
                    callbacks.done(response);
                }
            })
            .fail(function(request) {
                // check if error was a login error or lock out condition
                // if you change this text also change in Website::Checkout::BillShip
                if ( request.responseText == 'Account Locked Out' ) {
                    login.lockoutError( true );
                } else {
                    login.error(true);
                }
                login.cachedLoginResult = "notLoggedIn";

                if(callbacks
                    && callbacks.fail
                    ) {
                    callbacks.fail(request);
                }
            })
            .always(function() {
                login.loading(false);

                if(callbacks
                    && callbacks.always
                    ) {
                    callbacks.always();
                }
                login.inLogin = false;
                login.$recaptchaToken.val("")
            });
    };

    this.toggleRecover = function() {
        login.error(false);
        login.recoverError(false);

        login.$recover.toggle();
        login.$rememberMe.toggle();
        login.$rememberMeLbl.toggle();
        login.$desc.toggle();
        login.$recoverDesc.toggle();
        login.$recoverSubmit.toggle();
        login.$recoverCancel.toggle();
        login.$passwordLbl.toggle();
        login.$password.toggle();
        login.$submit.toggle();

        return false;
    };

    this.recover = function() {
        var email = login.$email.val();

        if(! email
            || ! isValidEmailAddress(email)
            ) {
            login.recoverError("Valid Email Address Required");
            return;
        }

        login.loading("Recovering Password");

        var postData = {
            'version' : checkoutAPIversion,
            'step'    : "billship",
            'action'  : "recover",
            'email'   : email
            };

        $.ajax({
            'url'      : window.checkoutEndpoint,
            'cache'    : false,
            'type'     : "POST",
            'dataType' : "json",
            'data'     : postData
            })
            .done(function(response) {
                login.toggleRecover();
                alert("Instructions to reset your password have been sent to the specified email address.");
                login.$password.focus();
            })
            .fail(function(request) {
                login.recoverError("Failed to Recover Password");
            })
            .always(function() {
                login.loading(false);
            });

        return false;
    };

    this.loading = function(loadingMsg) {
        if (loadingMsg) {
            login.$loadingMsg.html(loadingMsg);
            login.$loadingOverlay.show();
        }
        else {
            login.$loadingOverlay.hide();
        }
    };

    this.error = function(show) {
        if(show) {
            login.$error.show();
            login.$lockout.hide();
        }
        else {
            login.$error.hide();
            login.$lockout.hide();
        }
    };

    this.recoverError = function(errorMsg) {
        if(errorMsg) {
            login.$recoverError.find(".msg-text").html(errorMsg);
            login.$recoverError.show();
        }
        else {
            login.$recoverError.hide();
        }
    };

    this.lockoutError = function(errorMsg) {
        if(errorMsg) {
            login.$lockout.find(".msg-text").html(errorMsg);
            login.$lockout.show();
            login.$error.hide();
        }
        else {
            login.$lockout.hide();
            login.$error.hide();
        }
    };

    this.createError = function( show ) {
        if( ! login.$createError.length ) return login.error( show );

        login.$createError.toggle( show );
    }

    // Check whether the user is currently logged in, and then
    // either call the "loggedIn" or "notLoggedIn" callback functions
	// add a check for Full Login, and check it dependent on the fullLogin value in callbacks 
    this.checkLogin = function(callbacks) {
        if(! callbacks) return;

		var checkFullLogin = false;
		if ( callbacks.fullLogin ) {
			checkFullLogin = true;
			delete callbacks.fullLogin;
		}



        if(login.cachedLoginResult) {
            if(login.cachedLoginResult == "loggedIn"
                && callbacks.loggedIn
                ) {
				if ( checkFullLogin && login.cachedFullLogin != 'fullLogin' )  {
					if ( $('#loggedInEmail').length ) 
						$('#login-email').val( $('#loggedInEmail').val() );
                	callbacks.notLoggedIn();
				} else
                	callbacks.loggedIn();

                return;
            }
            else if(login.cachedLoginResult == "notLoggedIn"
                && callbacks.notLoggedIn()
                ) {
                callbacks.notLoggedIn();
                return;
            }
        }

        $.ajax({
            'url'      : window.checkoutEndpoint,
            'cache'    : false,
            'type'     : "POST",
            'dataType' : "json",
            'data'     : {
                'version' : checkoutAPIversion,
                'step'    : "session",
                'action'  : "load"
                }
            }).done(function(response) {
                if(response.data.loggedIn) {
                    if(callbacks.loggedIn) callbacks.loggedIn();

                    login.cachedLoginResult = "loggedIn";
                }
                else {
                    if(callbacks.notLoggedIn) callbacks.notLoggedIn();

                    login.cachedLoginResult = "notLoggedIn";
                }
            })
            .fail(function(request) {
                if(callbacks.notLoggedIn) callbacks.notLoggedIn();

                login.cachedLoginResult = "notLoggedIn";
            });
    }
    
    this.init();
};
